import { useStaticQuery, graphql } from "gatsby";

export const useStrapiNavigationActions = () => {
  const data = useStaticQuery(graphql`
    query GetNavigationActions { 
      strapi {
        ...NavigationActions
      }
    }
  `);

  return data.strapi.navigationActions;
}